const scoreManagement = resolve =>require(['@/components/admin/ScoreManagement.vue'], resolve)

export default {
    path: '/homePage/scoreManagement',
    component: scoreManagement,
    meta: {
        keepAlive: false, //该字段表示该页面需要缓存
        title: '成绩管理',
        path:'/homePage/scoreManagement',
        breadList: [
          {
            title: '首页',
            path: '/homePage'
          },
          {
            title: '成绩管理',
            path: '/homePage/scoreManagement'
          }
        ]
    },
}



// WEBPACK FOOTER //
// ./src/router/admin/scoreManagement.js